import { Button, Input, Form, Drawer, ColorPicker, message, Switch, DatePicker, InputNumber } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";

import endpoints from "../../utils/endpoints.js";
import { DeleteOutlined, FileImageOutlined, FileOutlined } from "@ant-design/icons";
import Media from "../Media/media.js";
import config from "../../utils/config.js";
import dayjs from "dayjs";

export default function Settings({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaKey, setMediaKey] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    if (data && Object.keys(data).length > 0 && typeof data.json === "string") {
      let auxData = JSON.parse(data.json);
      auxData.init_time = dayjs(auxData.init_time);
      auxData.end_time = dayjs(auxData.end_time);
      form.setFieldsValue(auxData);
    }
  }, [data]);

  function handleSubmit(values) {
    setIsButtonLoading(true);
    axios
      .post(endpoints.settings.update, {
        data: { values, name: "game" },
      })
      .then((res) => {
        closeDrawer(true);
        message.success("Definições do jogo foram editadas com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function closeDrawer(f) {
    form.resetFields();
    setIsButtonLoading(false);
    close(f);
  }

  function openMedia(k) {
    setMediaKey(k);
    setIsOpenMedia(true);
  }

  function closeMedia(res) {
    if (res) {
      form.setFieldValue(mediaKey, res[mediaKey]);
    }

    setMediaKey(null);
    setIsOpenMedia(false);
  }

  return (
    <Drawer
      width={800}
      title={`Definições do jogo`}
      open={open}
      onClose={closeDrawer}
      maskClosable={false}
      extra={[
        <Button className="mr-2" size="large" type="primary" onClick={form.submit} loading={isButtonLoading} disabled={isButtonLoading}>
          Guardar
        </Button>,
        <Button size="large" onClick={closeDrawer}>
          Cancelar
        </Button>,
      ]}
    >
      <Media mediaKey={mediaKey} open={isOpenMedia} close={closeMedia} />
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="init_time" label="Data de ínicio">
            <DatePicker size="large" showTime className="w-full" />
          </Form.Item>
          <Form.Item name="end_time" label="Data de fim">
            <DatePicker size="large" showTime className="w-full" />
          </Form.Item>
          <Form.Item name="max_tries" label="Tentativas máximas">
            <InputNumber size="large" placeholder="3" />
          </Form.Item>
          <Form.Item name="nr_questions" label="Nº de questões">
            <InputNumber size="large" placeholder="4" />
          </Form.Item>
          <div className="col-span-2">
            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.regulation_file !== currentValues.regulation_file}>
              {({ getFieldValue }) => {
                return (
                  <div className="relative">
                    <p className="pb-[8px]">Ficheiro</p>
                    <div
                      className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                      onClick={() => openMedia("regulation_file")}
                    >
                      {!getFieldValue("regulation_file") ? (
                        <div className="flex justify-center items-center flex-col p-10">
                          <FileOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar ficheiro</p>
                        </div>
                      ) : (
                        <div className="flex justify-center items-center flex-col p-10">
                          <FileOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">{getFieldValue("regulation_file")}</p>
                        </div>
                      )}
                    </div>

                    <Form.Item name={"regulation_file"} hidden>
                      <Input />
                    </Form.Item>
                  </div>
                );
              }}
            </Form.Item>
          </div>
        </div>
      </Form>
    </Drawer>
  );
}
